import { useContext } from 'react';
import { AppContext } from '../App/PageLevel/AppContextProvider';

export const useToast = () => {
    const obj = useContext(AppContext);
    return obj && obj.toastState;
};
